import { useQueryClient } from '@tanstack/react-query';
import { useUserQuery } from '../api/gql';
import { useImpersonateStorage } from '../store/impersonate';
import { useSafeNavigation } from './useSafeNavigation';

export const useImpersonate = () => {
  const { value, setValue, remove } = useImpersonateStorage();
  const { safeNavigate } = useSafeNavigation();
  const queryClient = useQueryClient();

  const impersonateUser = async (userId: string) => {
    setValue(userId);

    await queryClient.invalidateQueries({ queryKey: useUserQuery.getKey() });
    safeNavigate('/');
    location.reload();
  };

  const stopImpersonate = async () => {
    remove();
    await queryClient.invalidateQueries({ queryKey: useUserQuery.getKey() });
    safeNavigate('/admin/users');
    location.reload();
  };

  return {
    impersonateUser,
    stopImpersonate,
    impersonateUserToken: value,
  };
};
